import { fetchAppConfig } from '@/api/resources/appConfig.api';
import { AVAILABLE_FRONTEND_BASE_LANGUAGES } from '@/i18n/translations';
import { getLanguageEndonym } from 'common/utils/locale.utils';
import { defineStore } from 'pinia';

export interface ISelectableLanguage {
  code: string;
  name: string;
}

export interface IAppConfigState {
  environment: string;
  languageSwitchEnabled: boolean;
  selectableLanguages: ISelectableLanguage[] | null;
}

export const useAppConfigStore = defineStore('appConfig', {
  actions: {
    async load(): Promise<void> {
      try {
        const config = await fetchAppConfig();
        this.environment = config.environment;
        this.languageSwitchEnabled = config.languageSwitchEnabled;
        this.selectableLanguages = config.languages.map(({ code, name }) => ({ code, name }));
      } catch {
        this.environment = 'unknown';
        this.languageSwitchEnabled = false;
        this.selectableLanguages = null;
      }
    },
  },

  getters: {
    pickerLanguages(state): ISelectableLanguage[] {
      if (state.selectableLanguages != null) return state.selectableLanguages;
      return AVAILABLE_FRONTEND_BASE_LANGUAGES.map((code) => ({ code, name: getLanguageEndonym(code) }));
    },
    selectableCodes(state): string[] | null {
      return state.selectableLanguages?.map((language) => language.code) ?? null;
    },
  },

  state: (): IAppConfigState => ({
    environment: 'unknown',
    languageSwitchEnabled: false,
    selectableLanguages: null,
  }),
});
